import { InfoAdapterType } from "features/shared/types/info";
import { Article, ArticleType } from "../types/article";

export const initialFields: Article = {
    id: "",
    type: ArticleType.News,
    tags: [],
    properties: {
        type: InfoAdapterType.DefaultInfo,
    },
};

export const initialTagSuggestions: string[] = [
    "category:",
    "process:",
    "supplier:",
    "application:",
    "custom:",
];
